/**
 * 
 * @param {number} idSlider
 * @param {string} isLoopElemID
 * @param {string} numElemID
 * @param {number} swiperTotalCards
 */
function InizializzaSwiper(idSlider, isLoopElemID, numElemID, swiperTotalCards) {
    try {

        var isloop = false;
        var num = 5;

        try {
            var inpisloop = document.getElementById(isLoopElemID);
            if (inpisloop != null)
                isloop = inpisloop.value == 'true';
        } catch (e) {
            console.log(e);
        }

        try {
            var inpnum = document.getElementById(numElemID);
            if (inpnum != null)
                num = inpnum.value;
        } catch (e) {
            console.log(e);
        }

        var responsive = undefined;

        if (idSlider.includes('Alternative')) {
            responsive = {
                0: {
                    items: 1,
                    nav: true
                },
                650: {
                    items: 2,
                    nav: true
                },
                1050: {
                    items: 3,
                    nav: true
                },
                1400: {
                    items: 4,
                    nav: true
                },
                1750: {
                    items: 5,
                    nav: true
                },
                2000: {
                    items: 6,
                    nav: true
                }
            }
        }

        setTimeout(() => {
            var maxheight = 0;

            for (var i = 0; i < $('#' + idSlider + '.item.card-item').length; i++) {
                if ($('#' + idSlider + '.item.card-item')[i].offsetHeight > maxheight) {
                    maxheight = $('#' + idSlider + '.item.card-item')[i].offsetHeight;
                }
            }

            for (var i = 0; i < $('#' + idSlider + '.item.card-item').length; i++) {
                $('#' + idSlider + '.item.card-item')[i].style = 'height: ' + maxheight + 'px';
            }
        }, 500);
        var options = {
            slidesPerView: 3,
            spaceBetween: 25,
            // Fix (Claude): il modulo a11y di Swiper, sul focus di un elemento focusabile
            // (es. il <button> "aggiungi al carrello") dentro una slide non attiva, esegue
            // slideTo() portando quella slide in prima posizione: al primo click sul bottone
            // lo slider "scorre" e l'onclick va perso. La guardia interna dell'handler salta
            // lo slideTo se la slide è tra le visibleSlides, ma queste sono popolate solo con
            // watchSlidesProgress attivo. Attivandolo, il click su un bottone di una slide
            // già visibile non fa più scorrere lo slider.
            watchSlidesProgress: true,
            loop: swiperTotalCards > 6 ? true : false,
            centerSlide: true,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'slide',
            lazy: true,
            preloadImages: false,
            direction: 'horizontal',
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                600: {
                    slidesPerView: 3,
                },
                850: {
                    slidesPerView: 4,
                },
                1100: {
                    slidesPerView: 5,
                },
                1350: {
                    slidesPerView: 6,
                },
                1600: {
                    slidesPerView: 7,
                },
                1850: {
                    slidesPerView: 7,
                },
                2100: {
                    slidesPerView: 7,
                },
                2350: {
                    slidesPerView: 7,
                }
            }
        };
        if (idSlider.includes('lCarrelloDSConsiglia')) {
            options.breakpoints = {
                0: {
                    slidesPerView: 1
                },
                400: {
                    slidesPerView: 2
                },
                800: {
                    slidesPerView: 3
                },
                1000: {
                    slidesPerView: 3
                },
                1100: {
                    slidesPerView: 4
                },
                1400: {
                    slidesPerView: 5
                },
                1750: {
                    slidesPerView: 6

                },
            }
        }

        new Swiper('#' + idSlider, options);

        setTimeout(() => {

            $('.swiper').removeClass('d-none');
            $('.swiper').addClass('d-block');

            $('#swiper_preloader_' + idSlider).addClass('d-none');
        }, 500);

    } catch (ex) {
        console.log(ex);
    }
}